import { Injectable, signal } from '@angular/core';

export interface IDebugInfo {
    exceptionType?: string;
    message?:       string;
    stackTrace?:    string;
    innerException?: IDebugInfo;
}

export interface IDevError {
    name?:      string;
    message?:   string;
    source?:    string;
    statusCode: number;
    showInUI:   boolean;
    debug:      IDebugInfo;
}

@Injectable({ providedIn: 'root' })
export class DevErrorOverlayService {
    readonly error = signal<IDevError | null>(null);

    show(error: IDevError): void {
        this.error.set(error);
    }

    hide(): void {
        this.error.set(null);
    }
}
